import { useLazyQuery } from "@apollo/client";
import { TextField } from "@mui/material";
import { GET_REMAIN_STOCK } from "../../Schema/RemainStock";
import { useEffect } from "react";

export default function RemainProduct({
    warehouseId,
    listMaterialUnitId,
}) {

    // Get remain Stock product
    const [getRemainListMaterialUnitQty, { data }] = useLazyQuery(GET_REMAIN_STOCK);

    useEffect( () => {
        getRemainListMaterialUnitQty({
            variables: {
                warehouseId: warehouseId || null,
                listMaterialUnitId: listMaterialUnitId
            },
            onCompleted: ({getRemainListMaterialUnitQty}) => {
                console.log(getRemainListMaterialUnitQty?.remainInSmallUnit);
                // getRemainListMaterialUnitQty?.remainInSmallUnit;
            }
        })
    },[listMaterialUnitId,warehouseId])
    
    
    return(
        <TextField
            className="text-field"
            fullWidth
            size="small"
            type="number"
            disabled={true}
            placeholder="ក្នុងស្តុក"
            value={ listMaterialUnitId && data?.getRemainListMaterialUnitQty?.remainInSmallUnit } 
        />
    )
}